import OtpContainer from '../../../containers/Otp';
import AuthLayout from '../../../components/AuthLayout';

export default function Otp() {
  return (
    <AuthLayout maxWidth="xl" title="رابکس | تایید دو مرحله‌ای">
      <OtpContainer />
    </AuthLayout>
  );
}
